import { render, staticRenderFns } from "./CreateEmailCampaignDialog.vue?vue&type=template&id=2fab1c14"
import script from "./CreateEmailCampaignDialog.vue?vue&type=script&lang=js"
export * from "./CreateEmailCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports